
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/collections",
      function () {
        return require("private-next-pages/collections.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/collections"])
      });
    }
  